import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { FooterInfoAndLinksComponent } from '../../../app/content/layout/components/general/footer/components/footer-info-and-links/footer-info-and-links.component';
import { withCommonDecorators } from '../../_utils/story-helpers';

const meta: Meta<FooterInfoAndLinksComponent> = {
  title: 'Organisms/Footer/Footer Info & Links',
  component: FooterInfoAndLinksComponent,
  tags: ['autodocs'],
  decorators: [...withCommonDecorators()],
};
export default meta;
type Story = StoryObj<FooterInfoAndLinksComponent>;

export const Default: Story = {
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-footer-info-and-links')).toBeTruthy();
  },
};
